import { Injectable } from '@angular/core';
import { ApplicationConfig, RecordMode } from '@frontend-site/shared/data';
import { Repository } from '@frontend-site/shared/utils';
import { createStore, select, withProps } from '@ngneat/elf';
import { createInitialState, SessionState } from './session-state';

@Injectable({ providedIn: 'root' })
export class SessionRepository extends Repository<SessionState> {
    readonly applicationConfig$ = this.store.pipe(select((state) => state.config));
    readonly legacyAppVersion$ = this.store.pipe(select((state) => state.legacyAppVersion));

    readonly selectedCompanyId$ = this.store.pipe(select((state) => state.config?.companyId));

    get applicationConfig(): ApplicationConfig | undefined {
        return this.store.getValue().config;
    }

    updateUserProfile(userProfile: { language: string; user: { firstName: string; lastName: string; jobTitleKey?: string } }): void {
        const sessionInfo = this.store.getValue().config?.getSessionInformation();
        if (sessionInfo === undefined) {
            return;
        }

        const config = new ApplicationConfig({
            ...sessionInfo,
            user: { ...sessionInfo.user, ...userProfile.user },
            language: userProfile.language
        });
        this.update({ config });
    }

    public updateEntityCommentsSortDirection(sortEntityCommentsAsc: boolean): void {
        const sessionInfo = this.store.getValue().config?.getSessionInformation();
        if (sessionInfo === undefined) {
            return;
        }

        const config = new ApplicationConfig({
            ...sessionInfo,
            user: { ...sessionInfo.user, sortEntityCommentsAsc: sortEntityCommentsAsc }
        });
        this.update({ config });
    }

    constructor() {
        super(createStore({ name: 'SessionRepository' }, withProps<SessionState>(createInitialState())));
    }
}
